import React from 'react'
import s from "./dropdown.module.css";
import { FaChevronDown} from "react-icons/fa";

class Dropdown extends React.Component {

    state={
        openTab: ''
    }

    
    render(){

        const toggleClass = (title,openClass,closeClass)=>{
          if( this.state.openTab === title ){
            return openClass
          }
          else{
            return closeClass
          }
        }
        const triggerTab = (title)=>{
          if( this.state.openTab === title ){
            this.setState({openTab:''})
          }
          else{
            this.setState({openTab:title})
          }
        }
        return(
          <div className={`${this.props.className} ${s.container}`}>
              <ul className={s.acordeon}>
              {
                  this.props.data.map((item)=>
                      <li key={item.titulo} className={`${s.listItem}`}>
                          <button
                              className={`${s.button} ${toggleClass(item.titulo,s.button__open,s.button__closed)}`}
                              onClick={()=>{triggerTab(item.titulo)}}
                          >
                              {item.titulo}
                              <FaChevronDown size='1em' className={`${toggleClass(item.titulo,s.icon__open,s.icon__closed)}`}/>
                          </button>
                          <div className={`${s.contentItem} ${toggleClass(item.titulo,s.contentItem__open,s.contentItem__closed)}`}>
                            <div className={`${s.dropoverflow}`} >
                              {item.descripcion}
                            </div>

                          </div>
                      </li>
                  )
              }
              </ul>
          </div>
        )   
    }
    
}


Dropdown.defaultProps = {
  className: '',
};

export default Dropdown

